import React, {useContext } from 'react';
import styled from 'styled-components';
import PathwayCard from '../PathwayCard';
import { GlobalContext } from '../GlobalContext';

const Container = styled.div`


`;

const CardContainer = ({ pathways }) => {
  const { activePathway, setActivePathway } = useContext(GlobalContext);

  if (!pathways) return null;

  return (
    <Container>
      {pathways?.map((pathway) => (
        <PathwayCard
          key={`pathway__card__${pathway.name}`}
          pathway={pathway}
          active={pathway === activePathway}
          setActive={setActivePathway}
        />
      ))}
    </Container>
  )
};

export default CardContainer;
